export function getInitials(name: string | null | undefined): string {
  if (!name?.trim()) return "?";
  return name.trim().split(/\s+/).map(n => n[0]).join("").toUpperCase().slice(0, 2);
}

export function UserAvatar({
  photoURL,
  displayName,
  className = "w-10 h-10 rounded-xl text-[14px]",
}: {
  photoURL?: string | null;
  displayName?: string | null;
  className?: string;
}) {
  if (photoURL) {
    return (
      <img
        src={photoURL}
        alt={displayName ?? ""}
        className={`${className} object-cover`}
      />
    );
  }
  return (
    <div
      className={`${className} bg-gradient-to-br from-green-700 to-green-500 text-white flex items-center justify-center font-display font-black`}
    >
      {getInitials(displayName)}
    </div>
  );
}
